"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _TextField = _interopRequireDefault(require("@mui/material/TextField"));

var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));

var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));

var _excluded = ["containerStyles", "onSearch", "placeholder", "searchText"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'BrandSearchInput';
var classes = {
  underline: "".concat(PREFIX, "-underline"),
  root: "".concat(PREFIX, "-root"),
  disabled: "".concat(PREFIX, "-disabled")
};
var Root = (0, _styles.styled)('div')(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes.underline), {
    '&&&:before': {
      borderBottom: "1px solid ".concat(theme.palette.font.primary)
    }
  }), _defineProperty(_ref2, "& .".concat(classes.root), {
    color: theme.palette.font.primary,
    '& fieldset': {
      borderColor: theme.palette.font.primary
    },
    '&: hover fieldset': {
      borderColor: theme.palette.font.primary,
      border: '2px solid'
    }
  }), _defineProperty(_ref2, '& .BrandSearchInput-disabled', {
    WebkitTextFillColor: "".concat(theme.palette.font.primary, " !important"),
    '& fieldset': {
      borderColor: "".concat(theme.palette.font.primary, " !important"),
      opacity: 0.3
    },
    'div > svg': {
      opacity: 0.3
    }
  }), _ref2;
});

var BrandSearchInput = function BrandSearchInput(_ref3) {
  var containerStyles = _ref3.containerStyles,
      onSearch = _ref3.onSearch,
      placeholder = _ref3.placeholder,
      searchText = _ref3.searchText,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(Root, {
    style: containerStyles
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, props, {
    color: "primary",
    size: "small",
    variant: "outlined",
    value: searchText,
    onChange: onSearch,
    placeholder: placeholder || t('search'),
    InputProps: {
      classes: classes,
      startAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
        position: "start"
      }, /*#__PURE__*/_react.default.createElement(_Search.default, {
        color: "primary"
      }))
    }
  })));
};

BrandSearchInput.propTypes = {
  containerStyles: _propTypes.default.object,
  placeholder: _propTypes.default.string,
  searchText: _propTypes.default.string
};
var _default = BrandSearchInput;
exports.default = _default;